import { LoadableChangeAvatar } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function ChangeAvatarPage() {
  return (
    <>
      <Breadcrumb preCrumb={{ text: "profile", link: "/profile" }} />
      <LoadableChangeAvatar />
    </>
  );
}
